<iframe [src]="authUrl" height="0" width="0" class="border-0 d-none" (load)="onIframeLoad()" #authFrame></iframe>

<ng-container *ngIf="!loading && !initializing">
  <app *ngIf="loadApp"></app>
</ng-container>

<div class="container-fluid bg-white" *ngIf="loading || initializing">
  <div class="row">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center" style="height: 100vh">
      <img src="assets/images/splash-logo.gif" alt="Logo" class="temp-log" loading="eager" />
    </div>
  </div>
</div>